import { SignupUser } from './SignupUser';

export class User extends SignupUser {
    public id: string;
    public settings: Object;
}
